import script from "./Check.vue?vue&type=script&setup=true&lang=js"
export * from "./Check.vue?vue&type=script&setup=true&lang=js"

import "./Check.vue?vue&type=style&index=0&id=b64c2e8e&lang=scss"

const __exports__ = script;

export default __exports__